/** A note's id from the route: a server id is numeric, a note not yet uploaded is keyed by its uuid. */
export function noteIdFromParam(param: string | undefined): number | string | null {
  if (!param) return null;
  return /^\d+$/.test(param) ? Number(param) : param;
}
